import React from "react";
import { AnnouoncementsModal, Error, Header, Loader } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { BtnCell } from "./BtnCell";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import axios, { Axios } from "axios";
import { useEffect } from "react";
const NewAdvertisment = () => {
  const { currentMode } = useStateContext();
  const [addList, setaddList] = useState([]);

  const defaultColDefs = {
    sortable: true,
    filter: true,
  };

  

  const [columnDefs] = useState([
    { field: "category", flex: 2 },
    { field: "description", flex: 2 },
    { field: "dimensions", flex: 2 },
    { field: "approved", flex: 2 },
    { field: "price", flex: 2 },
    { field: "status", flex: 2 },
    { field: "whatsapp", flex: 2 },
    {
      field: "Action",
      flex: 5,
      cellRenderer: BtnCell,
      cellRendererParams: {
        clicked: (filed) => approveAd(filed),
      },
    },
  ]);

  const approveAd =async(filed) => {
    const data="";
    const config = {
        headers: { token: localStorage.getItem("userToken") },
      };
      const res = await axios.put(
        process.env.REACT_APP_API_HOSTNAME + `/api/v1/approveAd/${filed}`,data,
        config
      );
  };

  const getAdd = async () => {
    const config = {
      headers: { token: localStorage.getItem("userToken") },
    };
    const res = await axios.get(
      process.env.REACT_APP_API_HOSTNAME + "/api/v1/newAds",
      config
    );
    setaddList(res?.data?.ads);
  };

  useEffect(() => {
    getAdd();
  }, []);

  return (
    <div
      className={`m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl ${
        currentMode === "Dark" ? "ag-theme-alpine-dark" : "ag-theme-alpine"
      } h-[500px]`}
    >
      <Header title="New Advertisment" category="Page" />
      <div className="ag-theme-alpine h-[70%] w-[100%]">
        <AgGridReact rowData={addList} columnDefs={columnDefs}></AgGridReact>
      </div>
    </div>
  );
};

export default NewAdvertisment;
